export default __webpack_public_path__ + "static/media/Rectangle 224@2x.76c90ff3.png";